import styled, { css } from 'styled-components';

export const UnorderedList = styled.ul`
  ${({ theme, ...props }) => {
    return css`
      padding: 0.5rem 0;
    `;
  }};
`;

export const ListItem = styled.li`
  ${({ theme, ...props }) => {
    return css`
      font-size: ${theme.typography.font_size.text_sm};
      line-height: 1.8;

      display: flex;
      align-items: start;

      gap: 0.3rem;
      svg {
        flex-shrink: 0;
        margin-top: 0.24rem;
      }
    `;
  }};
`;
